import { createContext } from "react";

export const UidContext = createContext(); // Permet de stocké une var (Uid) dans le context